import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import { resolveDestination, type CollectionDestination } from './routing'

/**
 * A link to one of this area's own screens.
 *
 * It exists for the reason given in `routing.ts`: the collection routes are registered after this
 * area is built, so `to` cannot be checked against the router's tree yet. Every link inside the
 * area goes through here so that the one place that widening happens is the one place it has to be
 * undone later.
 */
export function CollectionsLink({
  destination,
  className,
  title,
  children,
}: {
  destination: CollectionDestination
  className?: string
  title?: string
  children: ReactNode
}) {
  const { to, params } = resolveDestination(destination)

  return (
    <Link to={to} params={params as never} className={className} title={title}>
      {children}
    </Link>
  )
}
